export default __webpack_public_path__ + "static/media/ORYX_MobilityIcon.0ad8e8e4.svg";